import type { ThemeConfig } from '#imports'

// The way we load and set themes is not an ideal solution, we have a SOT problem. It's probably better to let the useThemeConfig
// take care of this. We need to think about what we want to save and what not, and how to apply changes.
// Including bulk changes.
// See the middleware/3.load-center-theme.global.ts in the Volunteerly layer for more details.
export const useThemeConfig = () => {
  const appConfig = useAppConfig()
  const themeConfig = useState<ThemeConfig>('themeConfig', () => appConfig.theme as ThemeConfig)
  return { themeConfig }
}
